import type { AttachmentKind } from '../client'

export const MAX_ATTACHMENTS = 4
export const MAX_MEDIA_MB = 50
export const MAX_DOCUMENT_MB = 32

const MEDIA_TYPES = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/webp',
  'image/gif',
  'image/heic',
  'image/svg+xml',
  'audio/mpeg',
  'audio/mp3',
  'audio/mp4',
  'audio/x-m4a',
  'audio/m4a',
  'audio/aac',
  'audio/ogg',
  'audio/wav',
  'audio/flac',
  'video/mp4',
  'video/quicktime',
  'video/webm',
  'video/x-matroska',
]

export function kindFor(mimeType: string): AttachmentKind {
  return MEDIA_TYPES.includes(mimeType) ? (mimeType.split('/')[0] as AttachmentKind) : 'file'
}

export function fileError(file: File) {
  const isDocument = kindFor(file.type) === 'file'
  const limit = isDocument ? MAX_DOCUMENT_MB : MAX_MEDIA_MB
  if (file.size > limit * 1024 * 1024) {
    return `${isDocument ? 'Documents' : 'Images, audio and video'} must be under ${limit} MB.`
  }
  return ''
}
